import { Carousel } from "shared/components/atoms/Carousel";
import { Delay } from "components/atoms/Delay";
import Divider from "components/atoms/Divider";
import { Balloon } from "features/無料占いBot/components/Balloon";
import { Confirmable } from "features/無料占いBot/components/Confirmable";
import { RadioGroupCard } from "features/無料占いBot/components/RadioGroupCard";
import { useFormContext } from "react-hook-form";
import {
  Image as NextImage,
  ImageProps as NextImageProps,
} from "shared/components/atoms/Image";
import { eventName, eventAction, useGaEvent } from "shared/hooks/useGaEvent";
import { FreeFortuneTheme, FreeFortuneChatQuestion } from "shared/models";
import { genres } from "./ThemeCards";
import sum from "lodash/sum";
import { FreeFortuneThemeDetailSchema } from "@miror/types";

interface ImageProps extends NextImageProps {
  theme: FreeFortuneTheme | FreeFortuneThemeDetailSchema;
  question: FreeFortuneChatQuestion;
}

const Image = ({ theme, question, ...nextImageProps }: ImageProps) => {
  return (
    <div tw="relative overflow-hidden h-[107px]">
      <NextImage
        {...nextImageProps}
        width={222}
        height={107}
        layout="responsive"
        objectFit="cover"
        priority
      />
      <div tw="absolute inset-0 flex-center flex-col">
        <div tw="font-normal text-xs text-white leading-3 tracking-[.5px] text-center">
          {theme.name}
        </div>
        <Divider width="12px" margin={[7.5, 0]} />
        <div tw="font-bold text-xl leading-5 tracking-[.83px] text-white text-center">
          {question.body}
        </div>
      </div>
    </div>
  );
};

interface Props {
  themes: FreeFortuneTheme[] | FreeFortuneThemeDetailSchema[];
  theme?: FreeFortuneTheme | FreeFortuneThemeDetailSchema;
}

const fieldName = "answer";

export const SelectAnswer = ({ theme }: Props) => {
  const { watch } = useFormContext();
  const { sendEvent } = useGaEvent();

  const answerValue = watch(fieldName);
  const answer = theme?.freeFortuneChatQuestions.find(
    (question) => question.id.toString() === answerValue
  );

  const onClickConfirm = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.confirmAnswer,
      eventParams: {
        theme_id: answer.freeFortuneThemeId.toString(),
        answer_id: answer.id.toString(),
      },
    });
  };

  const genre = genres.find(
    (genre, idx1) =>
      theme.order <=
      sum(genres.map((genre, idx2) => (idx2 <= idx1 ? genre.chunk : 0)))
  );

  return (
    <Confirmable
      name={fieldName}
      text={`${answer?.body}についてのご鑑定をご希望でお間違いありませんか？`}
      onClickConfirm={onClickConfirm}
    >
      <Delay tw="mb-4">
        <Balloon>
          {`${theme?.name}のお悩みのご鑑定をご希望ですね。かしこまりました。\n\n続いて占いたい詳しい内容をお選びください🕴`}
        </Balloon>
        <Carousel
          tw="mt-[30px]"
          data={theme?.freeFortuneChatQuestions}
          renderItem={(data: FreeFortuneChatQuestion) => (
            <RadioGroupCard
              renderImage={
                <Image src={genre.thumbnail} theme={theme} question={data} />
              }
              text={data.description}
              radioInputName={fieldName}
              radios={[{ label: "この内容を占う", value: data.id }]}
            />
          )}
        />
      </Delay>
    </Confirmable>
  );
};
